import type { ClientDetails } from '@core/analytics/clientDetailsHeader';
import { toClientDetailsHeader } from '@core/analytics/clientDetailsHeader';
import type { Client } from '@core/api/utils';

export const createBookmarkForClass = <
  BookmarkAnalyticsProps extends Record<string, any>,
>(
  api: Client,
  classId: string,
  analytics: ClientDetails<BookmarkAnalyticsProps>,
) =>
  api.post(
    '/api/favorites/create',
    { rideId: classId },
    toClientDetailsHeader(analytics),
  );

export const deleteBookmarkForClass = <
  BookmarkAnalyticsProps extends Record<string, any>,
>(
  api: Client,
  classId: string,
  analytics: ClientDetails<BookmarkAnalyticsProps>,
) =>
  api.post(
    '/api/favorites/delete',
    { rideId: classId },
    toClientDetailsHeader(analytics),
  );
